import * as Yup from "yup";

const validationSchema = Yup.object({
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^[0-9]+$/, "OTP must be a number")
    .min(4, "OTP must be exactly 4 digits")
    .max(4, "OTP must be exactly 4 digits"),
});

export { validationSchema };
